import IndexLinks from "../IndexLinks";

const HelpTopicRechercherIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
  ]

  const links = [
    { title: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
    { title: "S'inscrire à des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicRechercherIndex